var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnetoone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_407_1181)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 36.1901,
    r: 4,
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4186 46.0144C18.4186 43.4573 20.4915 41.3844 23.0486 41.3844H24.9514C27.5085 41.3844 29.5814 43.4573 29.5814 46.0144V46.2569C29.5814 47.1093 28.8904 47.8002 28.0381 47.8002H19.9619C19.1096 47.8002 18.4186 47.1093 18.4186 46.2569V46.0144Z",
    fill: "#0069FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_407_1181)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1992 39.9999C32.1992 39.6685 32.4678 39.3999 32.7992 39.3999H47.1992C47.5306 39.3999 47.7992 39.6685 47.7992 39.9999C47.7992 40.3313 47.5306 40.5999 47.1992 40.5999H32.7992C32.4678 40.5999 32.1992 40.3313 32.1992 39.9999Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7753 35.5756C43.0097 35.3413 43.3896 35.3413 43.6239 35.5756L47.6239 39.5756C47.8582 39.81 47.8582 40.1899 47.6239 40.4242L43.6239 44.4242C43.3896 44.6585 43.0097 44.6585 42.7753 44.4242C42.541 44.1899 42.541 43.81 42.7753 43.5756L46.3511 39.9999L42.7753 36.4242C42.541 36.1899 42.541 35.81 42.7753 35.5756Z",
    fill: "#0069FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_407_1181)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 39.0001C57.5519 39.0001 58.81 37.742 58.81 36.1901C58.81 34.6381 57.5519 33.3801 56 33.3801C54.4481 33.3801 53.19 34.6381 53.19 36.1901C53.19 37.742 54.4481 39.0001 56 39.0001ZM56 40.1901C58.2091 40.1901 60 38.3992 60 36.1901C60 33.9809 58.2091 32.1901 56 32.1901C53.7909 32.1901 52 33.9809 52 36.1901C52 38.3992 53.7909 40.1901 56 40.1901Z",
    fill: "#0069FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9514 42.5744H55.0486C53.1487 42.5744 51.6086 44.1145 51.6086 46.0144V46.2569C51.6086 46.452 51.7668 46.6102 51.9619 46.6102H60.0381C60.2332 46.6102 60.3914 46.452 60.3914 46.2569V46.0144C60.3914 44.1145 58.8513 42.5744 56.9514 42.5744ZM55.0486 41.3844C52.4915 41.3844 50.4186 43.4573 50.4186 46.0144V46.2569C50.4186 47.1093 51.1096 47.8002 51.9619 47.8002H60.0381C60.8904 47.8002 61.5814 47.1093 61.5814 46.2569V46.0144C61.5814 43.4573 59.5085 41.3844 56.9514 41.3844H55.0486Z",
    fill: "#0069FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_1181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_407_1181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(32 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_407_1181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(48 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnetoone);
export default __webpack_public_path__ + "static/media/onetoone.c0ed81ea039b15906953765f8c18189e.svg";
export { ForwardRef as ReactComponent };